import React, { memo } from 'react';
import { Helmet } from 'react-helmet-async';
import { withRouter } from 'react-router-dom';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';

import { getLocaleUrlPath } from 'utils';

const APP_META_TAGS = [
  process.env.APP_DISABLE_CRAWLING === 'true'
    ? { name: 'robots', content: 'noindex, nofollow' }
    : {},
];

const APP_BODY_ATTRIBUTES = {};

const AppHelmet = memo(({ location }) => {
  const { locale } = useIntl();

  const links = [
    {
      rel: 'canonical',
      href: `https://minfin.com.ua${getLocaleUrlPath(locale)}${
        process.env.APP_ROUTER_BASENAME
      }${location.pathname}`,
    },
    {
      rel: 'alternate',
      hrefLang: 'uk',
      href: `https://minfin.com.ua/ua${process.env.APP_ROUTER_BASENAME}${location.pathname}${location.search}`,
    },
    {
      rel: 'alternate',
      hrefLang: 'ru',
      href: `https://minfin.com.ua${process.env.APP_ROUTER_BASENAME}${location.pathname}${location.search}`,
    },
  ];

  return (
    <Helmet
      htmlAttributes={{ lang: locale }}
      meta={APP_META_TAGS}
      link={links}
      bodyAttributes={APP_BODY_ATTRIBUTES}
    />
  );
});

AppHelmet.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
    search: PropTypes.string.isRequired,
  }).isRequired,
};

export default withRouter(AppHelmet);
